import { render, staticRenderFns } from "./OrdersFullWidthSearchInput.vue?vue&type=template&id=9a80a472&scoped=true&"
import script from "./OrdersFullWidthSearchInput.vue?vue&type=script&lang=js&"
export * from "./OrdersFullWidthSearchInput.vue?vue&type=script&lang=js&"
import style0 from "./OrdersFullWidthSearchInput.vue?vue&type=style&index=0&id=9a80a472&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a80a472",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
